import axios from "axios";

const fetchDimensions = (company_id, params, config) => {
  return axios.get(`/api/v1/companies/${company_id}/dimensions`, {
    params,
    ...config,
  });
};

const updateDimension = (company_id, dimension_item_id, dimension) => {
  return axios.patch(
    `/api/v1/companies/${company_id}/dimensions/${dimension_item_id}`,
    dimension,
  );
};

const fetchDimension = (company_id, dimension_item_id) => {
  return axios.get(
    `/api/v1/companies/${company_id}/dimensions/${dimension_item_id}`,
  );
};

const exportDimensions = (company_id, params) => {
  return axios.get(`/api/v1/companies/${company_id}/dimensions/export`, {
    params,
  });
};

const ApiCompanyDimensions = {
  fetchDimensions,
  updateDimension,
  fetchDimension,
  exportDimensions,
};

export default ApiCompanyDimensions;
